import React from 'react';
import classnames from 'classnames';
import CircularProgress from '@material-ui/core/CircularProgress';

export const RatesRefreshState = ({ classes }) => (
  <div className={classes.refreshRatesLoading}>
    <div className={classes.refreshRatesLoadingMessageWrapper}>
      <CircularProgress
        className={classes.refreshRatesLoadingCircularProgress}
      />
      <p
        className={classnames(
          classes.headline6,
          classes.refreshRatesLoadingMessage
        )}
      >
        Fetching rates…
      </p>
    </div>
  </div>
);

export default RatesRefreshState;
